import { Spin, Select, DatePicker, notification } from "antd";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { getAllEmployeesWithoutPaginationMethod } from '../../service/ApiServices';
import { getAllEmployeesMethod } from "../../service/ApiServices";
import { getAllAllowances, createEmployeeAllowance, getAllowanceById, updateEmployeeAllowance } from '../../service/allowanceService';
import moment from 'moment'; // Import moment for date handling

const CreateAllowance = ({ selectedAllowance, handleCancel, handleReload }) => {
    const [loading, setLoading] = useState(false);
    const [employeeData, setEmployeeData] = useState([]);
    const [allowanceTypes, setAllowanceTypes] = useState([]);
    const [selectedAllowanceType, setSelectedAllowanceType] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [amount, setAmount] = useState('');
    const [effectiveDate, setEffectiveDate] = useState(null); // State for effectiveDate
    const [api, contextHolder] = notification.useNotification();

    const showNotification = (type, message, description) => {
        api[type]({
            message,
            description,
            placement: "topRight",
            duration: 4.5,
        });
    };

    const fetchData = async () => {
        try {
            const data = await getAllAllowances();
            setAllowanceTypes(data);
        } catch (error) {
            console.error("Error fetching allowances:", error);
        }
    };
    useEffect(()=>{
    fetchData();
  },[])

    useEffect(() => {
       const fetchData = async () => {
            try {
                setLoading(true);
              await getAllEmployeesMethod({
                setEmployeeData: (responseData) => {
                  console.log('Employee API response:', responseData);
                  const employeeData = responseData?.data || [];
                  if (!Array.isArray(employeeData)) {
                    console.error('Employee data is not an array:', employeeData);
                    setEmployeeData([]);
                  } else {
                    setEmployeeData(employeeData);
                  }
                },
                setLoading,
                search: '',
                params: { page: 1, limit: 1000 },
              });
            } catch (error) {
                console.error('Error fetching data:', error);
                setEmployeeData([]);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchAllowanceDetails = async () => {
            if (selectedAllowance) {
                try {
                    const allowanceDetails = await getAllowanceById(selectedAllowance);
                    if (allowanceDetails) {
                        setSelectedEmployee(allowanceDetails.employee);
                        setSelectedAllowanceType(allowanceDetails.allowanceType);
                        setAmount(allowanceDetails.amount);
                        setEffectiveDate(allowanceDetails.effectiveDate ? moment(allowanceDetails.effectiveDate) : null); // Set effectiveDate
                    }
                } catch (error) {
                    console.error("Error fetching allowance details:", error);
                }
            }
        };

        fetchAllowanceDetails();
    }, [selectedAllowance]);

    const handleChangeEmployee = (value) => {
        setSelectedEmployee(value);
    };

    const handleSubmit = async () => {
        if (!selectedEmployee || !selectedAllowanceType || !amount || !effectiveDate) {
            showNotification("warning", "Missing information", "All fields are required to create an allowance.");
            return;
        }

        try {
            setLoading(true);
            if (selectedAllowance) {
                await updateEmployeeAllowance(
                    selectedAllowance,
                    selectedEmployee,
                    selectedAllowanceType,
                    amount,
                    effectiveDate.toISOString() // Convert to ISO string for API
                );
                showNotification("success", "Allowance updated", "Allowance details updated successfully.");
            } else {
                await createEmployeeAllowance(
                    selectedEmployee,
                    selectedAllowanceType,
                    amount,
                    effectiveDate.toISOString() // Convert to ISO string for API
                );
                showNotification("success", "Allowance saved", "Successfully saved allowance.");
            }
            handleReload();
            handleClickCancel();
        } catch (error) {
            showNotification("error", "Unable to save allowance", error.message || "Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleClickCancel = () => {
        handleCancel();
        setSelectedEmployee(null);
        setSelectedAllowanceType(null);
        setAmount('');
        setEffectiveDate(null); // Reset effectiveDate
    };

    const handleReset = () => {
        setSelectedEmployee(null);
        setSelectedAllowanceType(null);
        setAmount('');
        setEffectiveDate(null); // Reset effectiveDate
    };

    return (
        <>
            {contextHolder}
            <div className="modal-content">
            <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                    <h4>{selectedAllowance ? "Edit Allowance" : "Create Allowances"}</h4>
                    <p className="mb-0">Fill in the required fields to create an allowance</p>
                </div>
            </div>
            <div className="modal-body custom-modal-body">
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="input-blocks">
                                <label htmlFor="selectEmployee">Select Employee</label>
                                <Select
                                    className="select"
                                    placeholder="Select an employee"
                                    value={selectedEmployee || undefined}
                                    onChange={handleChangeEmployee}
                                    allowClear
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{ width: "100%", height: "40px" }}
                                >
                                      {Array.isArray(employeeData) && employeeData.length > 0 ? (
                      employeeData.map((emp) => {
                        const displayName = emp.full_name || (emp.first_name ? `${emp.first_name} ${emp.last_name || ''}`.trim() : "N/A");
                        return (
                          <Select.Option key={emp._id} value={emp._id}>
                            {emp.epf_number
                              ? `${emp.epf_number} - ${displayName}`
                              : `N/A - ${displayName}`}
                          </Select.Option>
                        );
                      })
                    ) : (
                      <Select.Option disabled>No employees available</Select.Option>
                    )}
                                    </Select>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="input-blocks">
                                <label>Allowance Categories</label>
                                <Select
                                    className="select"
                                    showSearch
                                    placeholder="Select an allowance category"
                                    value={selectedAllowanceType || undefined}
                                    onChange={(value) => setSelectedAllowanceType(value)}
                                    onClear={() => setSelectedAllowanceType(null)}
                                    allowClear
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={(allowanceTypes || []).map((allowance) => ({
                                        value: allowance._id,
                                        label: allowance.name,
                                    }))}
                                    style={{ width: "100%", height: "40px" }}
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="input-blocks">
                                <label>Enter Amount</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Amount"
                                    value={amount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Only numbers and decimal point
                                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                            setAmount(value);
                                        }
                                    }}
                                    min="0"
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="input-blocks">
                                <label>Effective Date</label>
                                <DatePicker
                                    className="form-control"
                                    placeholder="Select effective date"
                                    value={effectiveDate}
                                    onChange={(date) => setEffectiveDate(date)}
                                    style={{ width: "100%", height: "40px" }}
                                    format="YYYY-MM-DD"
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <button
                            type="button"
                            className="btn btn-reset"
                            onClick={handleReset}
                        >
                            Reset
                        </button>
                        <div>
                             <button
                                type="button"
                                className="btn btn-cancel me-2"
                                onClick={handleClickCancel}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-submit"
                            >
                                {loading ? <Spin size='small' /> : "Save"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        </>
    );
};

CreateAllowance.propTypes = {
    handleReload: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    selectedAllowance: PropTypes.string 
};

export default CreateAllowance;